import moment from 'moment';
import { today } from './today';

export const isDateUCTSameAsToday = (date1: string) => {
  const UTCDate = moment(date1)
    .utc()
    .startOf('day');

  const todayUTC = today.utc().startOf('day');

  return UTCDate.isSame(todayUTC);
};
